import React, {ReactNode, useState} from 'react';

import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';

import {SortingDirections} from './constants';

import {filterHeader, sortButton, sortButtonActive} from './filter-header.module.styl';

export type Props = {
    caption: string,
    onSort?: (direction: SortingDirections) => void,
    isSorted?: boolean,
    contentAfter?: ReactNode,
};

export const SortableHeader = (props: Props) => {
    const {
        caption,
        onSort,
        isSorted,
        contentAfter,
    } = props;
    const [isAsc, setIsAsc] = useState(false);

    const sortToggler = () => {
        if (onSort) {
            onSort(isAsc ? SortingDirections.ASC : SortingDirections.DESC);
            setIsAsc(prevState => !prevState);
        }
    };

    return (
        <Group justify="space-between" className={filterHeader} alignItems="center">
            {caption}
            <Group gap="s" alignItems="start">
                {(isSorted || onSort) ? (
                    <Item className={isSorted ? sortButtonActive : sortButton}>
                        <BasicIconButton
                            iconProps={{type: isAsc ? Icons.LONG_ARROW_UP : Icons.LONG_ARROW_DOWN}}
                            onClick={sortToggler}
                        />
                    </Item>
                ) : null}
                {contentAfter ? (
                    <Item>
                        {contentAfter}
                    </Item>
                ) : null}
            </Group>
        </Group>
    );
};
